/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { Store } from "redux";

import { getActiveNewsAsync } from "~/features/news/thunks";
import { AppDispatch, RootState } from "~/state/types";
import reportError from "~/utils/reportError";

export const createNewsLoginSubscriber = (store: Store<RootState>) => {
  let currentResellerId: number | null = null;

  return () => {
    const prev = currentResellerId;
    currentResellerId = store.getState().auth.account?.resellerId ?? null;

    if (!!currentResellerId && currentResellerId !== prev) {
      const dispatch: AppDispatch = store.dispatch;

      dispatch(getActiveNewsAsync()).catch(reportError);
    }
  };
};
